const getEnv = (key, fallback = "") => {
  const value = process.env[key];
  return typeof value === "string" ? value : fallback;
};

export const APP_CONFIG = {
  /** Opt-in: send usage to Firebase Analytics / Google Analytics (default off). */
  firebaseEnableAnalytics: getEnv("REACT_APP_FIREBASE_ENABLE_ANALYTICS", "") === "true",
  /**
   * Optional: Firebase App Check (reCAPTCHA). Register the web app in Firebase Console → App Check,
   * then set the site key. Use V3 provider if you registered reCAPTCHA v3 instead of Enterprise.
   */
  firebaseAppCheckSiteKey: getEnv("REACT_APP_FIREBASE_APPCHECK_SITE_KEY", ""),
  firebaseAppCheckUseV3: getEnv("REACT_APP_FIREBASE_APPCHECK_USE_V3", "") === "true",
  emailjsServiceId: getEnv("REACT_APP_EMAILJS_SERVICE_ID", ""),
  emailjsTemplateId: getEnv("REACT_APP_EMAILJS_TEMPLATE_ID", ""),
  emailjsPublicKey: getEnv("REACT_APP_EMAILJS_PUBLIC_KEY", ""),
  firebaseApiKey: getEnv("REACT_APP_FIREBASE_API_KEY", ""),
  firebaseAuthDomain: getEnv("REACT_APP_FIREBASE_AUTH_DOMAIN", ""),
  firebaseProjectId: getEnv("REACT_APP_FIREBASE_PROJECT_ID", ""),
  firebaseStorageBucket: getEnv("REACT_APP_FIREBASE_STORAGE_BUCKET", ""),
  firebaseMessagingSenderId: getEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID", ""),
  firebaseAppId: getEnv("REACT_APP_FIREBASE_APP_ID", ""),
  firebaseMeasurementId: getEnv("REACT_APP_FIREBASE_MEASUREMENT_ID", ""),
  stripeUnlimitedUrl: getEnv("REACT_APP_STRIPE_UNLIMITED_URL", ""),
  /**
   * If true: start checkout via Cloud Function `createStripeCheckoutSession` so success_url matches
   * window.location.origin (localhost, LAN IP, or production) — no single Payment Link redirect in Dashboard.
   * Requires deployed Functions + STRIPE_PRICE_ID on the server.
   */
  stripeCheckoutSession: getEnv("REACT_APP_STRIPE_CHECKOUT_SESSION", "") === "true",
  /**
   * Optional: canonical public origin (https://your-domain.com) for Stripe "After payment" URL docs.
   * If unset, BillingPage uses window.location.origin (correct when you open the app on the real site).
   */
  publicSiteUrl: getEnv("REACT_APP_PUBLIC_SITE_URL", "").replace(/\/$/, ""),
};
